<template>
    <div :style="style" class="all">
        <div class="item">
            <div v-if="$getConfigText(block.inner.title)" class="special">
                <span v-html="$getConfigText(block.inner.title)"></span>
            </div>
            <div class='content'>
                <span 
                    v-html="$getConfigText(block.inner.introTitle)"
                    v-if="$getConfigText(block.inner.introTitle)" 
                    class="title"></span>
                <div class="middle">
                    <p class="content" 
                        v-html = '$getConfigText(block.inner.introContent)'></p>
                    <span :style="linkStyle"
                        v-if="block.isLink"
                        v-show="block.linkForm.status"
                        @click="jumpMess" 
                        v-html="$getConfigText(block.linkForm.text)" 
                        class="btnText">
                        </span> 
                </div> 
            </div>
            <img :src="block.inner.img" alt="图片">
        </div>
    </div> 
</template>

<style lang='scss' scoped>
    .all{
        .item{
            display: flex;
            flex-direction: column;
            align-items: center;
            .special{
                display: flex;
                justify-content: center;
                margin-top: 1.07rem;
                margin-bottom: 0.8rem;
                width: 8.93rem;
                span{
                    font-size: 0.64rem;
                    line-height: 0.88rem;
                    font-weight: bold;
                    text-align: center;
                }
            }
            .content{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .title{
                    margin-top: 1.07rem;
                    margin-bottom: 0.8rem;
                    text-align: center;
                    font-size: 0.64rem;
                    line-height: 1.4;
                    font-weight: bold;
                }
                .middle{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-bottom: 1rem;
                    .content{
                        width: 8.63rem;
                        font-size: 0.37rem;
                        line-height: 0.69rem;
                        text-align: center;
                    }
                    .btnText{
                        margin-top: 0.4rem;
                        font-size: 0.43rem;
                        font-weight: bold;
                        color:#2c84dd;
                    }
                }
                
            }
            img{
                display: block;
                margin-bottom: 1.07rem;
                width: 8.93rem;
                height: 5.97rem;
                border-radius: 7px;
            }
        }
    }
    
</style>

<script>
export default {
    name:'LightSpot',
    props:{
        block:Object
    },
    computed:{
        style(){
            return `background-color:${this.block.backColor};
                    color:${this.block.fontColor}`
        },
        linkStyle(){
            return `color:${this.block.linkForm.textColor}`
        }
    },
    methods: {
        jumpMess(){
            window.location.href = this.block.linkForm.url
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/templates/m-blocks/light-spot.vue